import React from 'react';
import { Admin, Resource, CustomRoutes  } from 'react-admin';
import { UserList } from './models/users';
import { CodeList, CodeEdit, CodeCreate } from './models/codes';
import { ActivityList } from './models/activites';
import { SiteList, SiteEdit, SiteCreate } from './models/sites';
import { OverlayList, OverlayEdit, OverlayCreate } from './models/overlays';
import { TrackList, TrackEdit, TrackCreate } from './models/tracks';
import { StationList, StationEdit, StationCreate } from './models/stations';
import { MenuItemList, MenuItemEdit, MenuItemCreate } from './models/menu_items';
import { SubscriptionModelList, SubscriptionModelEdit, SubscriptionModelCreate } from './models/subscription_models';
import { SubscriptionPlanList, SubscriptionPlanEdit, SubscriptionPlanCreate } from './models/subscription_plans';
import MyLayout from './providers/myLayout'
import { Dashboard } from './models/dashboard';
import UserIcon from '@material-ui/icons/Group';
import SiteIcon from '@material-ui/icons/Terrain';
import TrackIcon from '@material-ui/icons/Navigation';
import CodeIcon from '@material-ui/icons/Dialpad';
import OverlayIcon from '@material-ui/icons/Map';
import StationIcon from '@material-ui/icons/Flag';
import MenuItemIcon from '@material-ui/icons/FeaturedPlayList';
import SubscriptionIcon from '@material-ui/icons/Subscriptions';
import CardMembershipIcon from '@material-ui/icons/CardMembership';
import uploadFileDataProvider from './providers/addUploadFeature'
import authProvider from './providers/authProvider';
import { createTheme } from '@material-ui/core/styles';
import orange from '@material-ui/core/colors/orange';
import red from '@material-ui/core/colors/red';
import {LocationMapList} from './models/locations_map';

const myTheme = createTheme({
  palette: {
      primary: orange,
      secondary: {
        main: '#0B4836',
      },
      error: red,
      contrastThreshold: 3,
      tonalOffset: 0.2,
  },
  typography: {
      // Use the system font instead of the default Roboto font.
      fontFamily: [
          '-apple-system',
          'BlinkMacSystemFont',
          '"Segoe UI"',
          'Arial',
          'sans-serif',
      ].join(','),
  },
  overrides: {
    MuiChip: {
      root: {
        // Target chips within AutocompleteArrayInput using CSS selector
        '&[class*="RaAutocompleteArrayInput-chip"]': {
          backgroundColor: '#000000 !important',
          color: '#ffffff !important',
          '& .MuiChip-deleteIcon': {
            color: '#ffffff !important',
          },
        },
      },
      deletable: {
        // Additional override for deletable chips
        '&[class*="RaAutocompleteArrayInput"]': {
          backgroundColor: '#000000 !important',
          color: '#ffffff !important',
        },
      },
    },
  },
});

const App = () => (   
<Admin layout={MyLayout} dataProvider={uploadFileDataProvider} theme={myTheme}
dashboard={Dashboard} authProvider={authProvider}>
    {permissions => permissions === 'admin' ?
     [
      <Resource name="users" list={UserList} icon={UserIcon}/>,
      <Resource name="codes" icon={CodeIcon} list={CodeList} 
      edit={CodeEdit} create={CodeCreate}/>,
      <Resource name="sites" list={SiteList} icon={SiteIcon} 
      edit={SiteEdit} create={SiteCreate}/>,
      <Resource name="tracks" list={TrackList} edit={TrackEdit} 
      icon={TrackIcon} create={TrackCreate} options={{ label: 'Courses' }}/>,
      <Resource name="overlays" icon={OverlayIcon} list={OverlayList} edit={OverlayEdit} 
      create={OverlayCreate} options={{ label: 'Map Images' }}/>,
      <Resource name="points"/>,
      <Resource name="riddles"/>,
      <Resource name="stations" icon={StationIcon} list={StationList}
      edit={StationEdit} create={StationCreate}/>,
      <Resource name="activities" list={ActivityList} options={{ label: 'Score Table' }}/>,
      <Resource name="locations_map" list={LocationMapList} options={{ label: 'Locations Map' }}/>,
      <Resource name="menu_items" icon={MenuItemIcon} list={MenuItemList} create={MenuItemCreate} 
      edit={MenuItemEdit} options={{ label: 'Menu Items' }}/>,
      <Resource name="subscription-models" icon={SubscriptionIcon} list={SubscriptionModelList} 
      create={SubscriptionModelCreate} edit={SubscriptionModelEdit} options={{ label: 'Subscription Models' }}/>,
      <Resource name="subscription-plans" icon={CardMembershipIcon} list={SubscriptionPlanList} 
      create={SubscriptionPlanCreate} edit={SubscriptionPlanEdit} options={{ label: 'Subscription Plans' }}/>,
     
    ] : 
    permissions == 'user'? 
    [
      <Resource name="activities" list={ActivityList} options={{ label: 'Score Table' }}/>,
      <Resource name="locations_map" list={LocationMapList} options={{ label: 'Locations Map' }}/>,
      <Resource name="sites"/>,
      <Resource name="tracks"/>,
    ] :
    [    
      <Resource name="activities" list={ActivityList} options={{ label: 'Score Table' }}/>,
      <Resource name="locations_map" list={LocationMapList} options={{ label: 'Locations Map' }}/>,
      <Resource name="sites"/>,
      <Resource name="tracks"/>,
    ]}
  </Admin>
  );


export default App;
